import { createFileRoute } from "@tanstack/react-router";
import { ExamForm } from "@client/components/ExamForm";

export const Route = createFileRoute("/_authenticated/exams/new")({
  component: NewExamPage,
});

function NewExamPage() {
  return <ExamForm />;
}
